/**
 * Progressive Button on click
 * @module progressiveBtn
 */

import $ from 'jquery';
import Keyboard from './keyboard';
import registerJQueryPlugin from '../lib/register-jquery-plugin';
export const PLUGIN_NAME = 'progressiveBtn';
export const CLICK_HANDLER = 'click';
export const DEFAULTS = {
  container: '.js-progressive-btn-block',
  progressCopy: 'loading..',
  barStyle: 'light',
  changeBtn: false,
};

/**
 * Merges together all the options and the various conditions in which they
 * can be set.
 * @param  {jQuery} $el - tab link
 * @param  {Object} [options={}] - Any options provided upon initialization
 * @return {Object} Immutable version of the options
 */
const mergeOptions = ($el, options = {}) => {
    return Object.assign({}, DEFAULTS, $el.data(), options);
};

/**
 * Handle Toggling Event
 * @param  {jQuery} $el - button /element that toggles text
 * @param  {Object} [options={}] - Any options provided upon initialization
 */

 const progressBar = (progressCopy, barStyle) => {
   return `<div class="progress-bar__block progress-bar--${barStyle}">
       <div class="progress-bar__hed">
          ${progressCopy}
        </div>
       <div class="progress-bar">
       </div>
   </div>
   `;
 }

 const destroyAllProgressive = ($el, opts) => {
   const isActive = $el.hasClass('active');
   const { changeBtn, container } = opts;
   const $progressiveBlock = $el.closest(container);
   if(isActive && changeBtn) {
     $progressiveBlock.find('.progress-bar__block').remove();
     $progressiveBlock.find('.js-progressive-new-btn').removeClass('u-hide');
   }
   if(isActive && !changeBtn) {
     $progressiveBlock.find('.progress-bar__block').remove();
     $el.removeClass('u-hide');
   }
 }

 const progressiveFlow = ($el, opts) => {
    const { container, progressCopy, barStyle } = opts;
    $el.addClass('active').addClass('u-hide');
    $el.closest(container).append(progressBar(progressCopy, barStyle));
 }

 const setEventListeners = ($el, opts) => {
   $el.on(CLICK_HANDLER, evt => {
     progressiveFlow($el, opts);
   });
 };


/**
 * Initializes Header.
 * @param {HTMLElement} el - trigger
 * @param {Object} options - Options used for wiring up the modal
 * @see DEFAULTS
 */
export default function progressiveBtn(el, options = {}) {
  const $el = $(el);
  const opts = mergeOptions($el, options);
  setEventListeners($el, opts);
  return {
    destroy: () => destroyAllProgressive($el, opts),
  };
}

registerJQueryPlugin(PLUGIN_NAME, progressiveBtn);



// WEBPACK FOOTER //
// ./styleguide/src/assets/modules/progressive-btn.js